import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { useState } from "react";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import imageUploader from "../../../../src/assets/images/image.png";
import info from "../../../../src/assets/images/info.png";
import closeIcon from "../../../assets/images/crosicon.svg";
import video from "../../../assets/images/video.svg";

const VideoProofModal = ({ show, onCloseClick, onSubmit,orderId }: any) => {
    const [videos, setVideos] = useState<File[]>([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(event.target.files || []);
        const videoFiles = files.filter((file): file is File => file.type.startsWith("video/"));
        setVideos((prevVideos) => [...prevVideos, ...videoFiles]);
    };

    const handleRemoveVideo = (index: number) => {
        setVideos((prevVideos) => prevVideos.filter((_, i) => i !== index));
    };

    const handleSubmit = () => {
        if (!isSubmitting) {
            setIsSubmitting(true);
            onSubmit(videos);
        }
    };


    return (
        <Modal isOpen={show} centered={true} className="reasonModl">
            <ModalBody className="modal_Body">
                <img
                data-testing-id="closeIcon"
                onClick={onCloseClick}
                className='closeIconModal'
                src={CLoseImg}
                alt=""
            />
                <div className="mainDv videoModalDv">
                    <div className="flexDv">
                        <h1>Order Details ({orderId})</h1>
                        <a>
                            <div className="dot"></div>
                            Packaging Confirmation
                        </a>
                    </div>
                    <p>Before you proceed, please upload a video of the sealed package.</p>

                    <div className="listDv">
                        <span>This ensures:</span>
                        <ul>
                            <li>✅ The box is properly sealed</li>
                            <li>✅ No damage before shipping</li>
                            <li>✅ Proof of packaging for dispute resolution</li>
                        </ul>
                    </div>

                    <h5 className="upload m-0"> Upload Box Video</h5>
                    <label
                        htmlFor="video-upload"
                        className="flex m-0 flex-col items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-blue-400 hover:bg-blue-50 relative borderDv"
                        data-testing-id="videoUploader_videoModal"
                    >
                        {/* Show Upload Text if No Videos */}
                        {!videos.length && (
                            <div className="textUpload">
                                <img src={imageUploader} alt="Upload Icon" className="iconImg" />
                                <p>Upload or Drop file here.</p>
                                <p>Max file size: 10 MB</p>
                            </div>
                        )}

                        <input
                            id="video-upload"
                            type="file"
                            multiple
                            accept="video/*"
                            className="hidden"
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                        />

                        <div className="videoRow">
                            {videos.map((video, index) => (
                                <div key={index} data-testing-id={"video" + index} className="videoDv">
                                    <video
                                        src={URL.createObjectURL(video)}
                                        controls
                                        className="w-full h-full object-cover rounded-md"
                                    />
                                    <img
                                        src={closeIcon}
                                        onClick={() => handleRemoveVideo(index)}
                                        data-testing-id="closeIcn_videoModal"
                                        alt="Close"
                                        className="closeIcnoDv"
                                    />
                                </div>
                            ))}
                        </div>

                        <img className="absolute top-2 right-2 text-blue-400 text-xl iconDv" src={info} alt="Info" />
                    </label>

                    <div className="multiVideo" data-testing-id="multiVideos">
                    <label
                        htmlFor="video-upload"
                            data-testing-id="videoUploader_videoModal"
                            className="formediaupload"
                    >
                    <img src={video} alt="Video Icon" />
                        <input
                            id="video-upload"
                            type="file"
                            multiple
                            accept="video/*"
                            className="hidden"
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                        />
                            <h6 className="text-secondary ms-2">Upload Video</h6>
                            </label>
                    </div>

                    <div className="btnDv w-100">
                        <button
                            type="button"
                            className="w-100 mt-0"
                            data-testing-id="submitBtn_videoModal"
                            onClick={handleSubmit}
                            disabled={isSubmitting || videos.length === 0}
                        >
                            {isSubmitting ? "Submitting..." : "Confirm & Submit"}
                        </button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

VideoProofModal.propTypes = {
    onCloseClick: PropTypes.func,
    show: PropTypes.any,
    onSubmit: PropTypes.func.isRequired,
    orderId: PropTypes.any
};

export default VideoProofModal;
